module.exports = __webpack_public_path__ + "img/apt-2.c2387584.jpg";